import React from 'react'
import {useLocation} from 'react-router-dom'
import * as Sentry from '@sentry/react'
import {useMount} from 'ahooks'

import {useEnv} from 'hiya-common/src/reducers/env'

import {closeCurWindow} from '@xc/hiya-jsbridge'
import styles from './Fallback.module.scss'

export const Fallback = () => {
  const {deviceinfo} = useEnv()
  const location = useLocation()

  useMount(() => {
    const isSend = deviceinfo.h_m && location.pathname !== '/'
    if (isSend) {
      Sentry.captureEvent({
        message: '白屏异常',
        level: 'error',
      })
    }
  })
  return (
    <div className={styles.parent}>
      <div className={styles.children}>
        <div>There are some minor problems with the page</div>
        <div onClick={() => closeCurWindow()} className={styles.close}>
          click close
        </div>
      </div>
    </div>
  )
}
